/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './MessageIcon.style';

import BaseIcon from 'src/shared/ui/component/icon/BaseIcon';

import svg from './MarketNavItemIcon.svg';

type Props = {
  className?: string,
  title?: string,
};

const useStyles = createUseThemeStyles(styles);

const MarketNavItemIcon = ({ className, title }: Props): React.Node => {
  const classes = useStyles();

  return (
    <BaseIcon
      className={classNames(classes.root, className)}
      svg={svg}
      title={title}
    />
  );
};

export default compose(React.memo)(MarketNavItemIcon);
